@let parsedHtml = html | appFn: parseContentBuilderVariables$ | async;
@if (parsedHtml) {
  <div [innerHTML]="$any(parsedHtml) | safeHtml"></div>
}
